//   产品管理
import { Layout } from '@/utils/routerHelper'

export default {
  path: '/product',
  redirect: '/product/direct-selling-product-list',
  component: Layout,
  name: 'Product',
  meta: {
    title: '产品管理',
    icon: 'vi-ant-design:dashboard-filled'
  },
  children: [
    {
      path: 'direct-selling-product-list',
      component: () => import('@/views/Product/DirectSelling/ProductList/Index.vue'),
      name: 'DirectSellingProductList',
      meta: {
        title: '直销区产品列表'
      },
      children: [
        {
          path: 'all-version',
          component: () => import('@/views/Product/DirectSelling/AllVersion/Index.vue'),
          name: 'DirectSellingAllVersion',
          meta: {
            title: '全部版本列表',
            hidden: true,
            canTo: true,
            activeMenu: '/product/direct-selling-product-list'
          }
        },
        {
          path: 'single-product',
          component: () => import('@/views/Product/DirectSelling/SingleProduct/Index.vue'),
          name: 'DirectSellingSingleProduct',
          meta: {
            title: '新增单品',
            hidden: true,
            canTo: true,
            activeMenu: '/product/direct-selling-product-list'
          }
        },
        {
          path: 'combination-product',
          component: () => import('@/views/Product/DirectSelling/CombinationProduct/Index.vue'),
          name: 'DirectSellingCombinationProduct',
          meta: {
            title: '新增组合产品',
            hidden: true,
            canTo: true,
            activeMenu: '/product/direct-selling-product-list'
          }
        },
        {
          path: 'marketing',
          component: () => import('@/views/Product/DirectSelling/Marketing/Index.vue'),
          name: 'DirectSellingMarketing',
          meta: {
            title: '营销信息',
            hidden: true,
            canTo: true,
            activeMenu: '/product/direct-selling-product-list'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Product/DirectSelling/ProductDetail/Index.vue'),
          name: 'DirectSellingProductDetail',
          meta: {
            title: '产品详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/direct-selling-product-list'
          }
        }
      ]
    },
    {
      path: 'direct-selling-product-audit',
      component: () => import('@/views/Product/DirectSelling/ProductAudit/Index.vue'),
      name: 'DirectSellingProductAudit',
      meta: {
        title: '直销区产品审批'
      },
      children: [
        {
          path: 'audit-detail',
          component: () => import('@/views/Product/DirectSelling/AuditDetail/Index.vue'),
          name: 'DirectSellingAuditDetail',
          meta: {
            title: '直销区产品审批详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/direct-selling-product-audit'
          }
        }
      ]
    },
    {
      path: 'config',
      component: () => import('@/views/Product/Config/Index.vue'),
      name: 'ProductConfig',
      meta: {
        title: '产品配置'
      },
      children: [
        {
          path: 'front-category-map-detail',
          component: () => import('@/views/Product/Config/FrontCategory/MapDetail/Index.vue'),
          name: 'ProductFrontCategoryMapDetail',
          meta: {
            title: '映射详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/config'
          }
        },
        {
          path: 'product-logo-map-detail',
          component: () => import('@/views/Product/Config/ProductLogo/MapDetail/Index.vue'),
          name: 'ProductLogoMapDetail',
          meta: {
            title: '映射详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/config'
          }
        }
      ]
    },
    {
      path: 'public-product-list',
      component: () => import('@/views/Product/Public/ProductList/Index.vue'),
      name: 'PublicProductList',
      meta: {
        title: '公共区产品列表'
      },
      children: [
        {
          path: 'all-version',
          component: () => import('@/views/Product/Public/AllVersion/Index.vue'),
          name: 'PublicAllVersion',
          meta: {
            title: '全部版本列表',
            hidden: true,
            canTo: true,
            activeMenu: '/product/public-product-list'
          }
        },
        {
          path: 'single-product',
          component: () => import('@/views/Product/Public/SingleProduct/Index.vue'),
          name: 'PublicSingleProduct',
          meta: {
            title: '新增单品',
            hidden: true,
            canTo: true,
            activeMenu: '/product/public-product-list'
          }
        },
        {
          path: 'combination-product',
          component: () => import('@/views/Product/Public/CombinationProduct/Index.vue'),
          name: 'PublicCombinationProduct',
          meta: {
            title: '新增组合产品',
            hidden: true,
            canTo: true,
            activeMenu: '/product/public-product-list'
          }
        },
        {
          path: 'marketing',
          component: () => import('@/views/Product/Public/Marketing/Index.vue'),
          name: 'PublicMarketing',
          meta: {
            title: '营销信息',
            hidden: true,
            canTo: true,
            activeMenu: '/product/public-product-list'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Product/Public/ProductDetail/Index.vue'),
          name: 'PublicProductDetail',
          meta: {
            title: '产品详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/public-product-list'
          }
        }
      ]
    },
    {
      path: 'public-product-audit',
      component: () => import('@/views/Product/Public/ProductAudit/Index.vue'),
      name: 'PublicProductAudit',
      meta: {
        title: '公共区产品审批'
      },
      children: [
        {
          path: 'audit-detail',
          component: () => import('@/views/Product/Public/AuditDetail/Index.vue'),
          name: 'PublicAuditDetail',
          meta: {
            title: '公共区产品审批详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/public-product-audit'
          }
        }
      ]
    },
    {
      path: 'lead-product-list',
      component: () => import('@/views/Product/Lead/ProductList/Index.vue'),
      name: 'LeadProductList',
      meta: {
        title: '领参区产品列表'
      },
      children: [
        {
          path: 'all-version',
          component: () => import('@/views/Product/Lead/AllVersion/Index.vue'),
          name: 'LeadAllVersion',
          meta: {
            title: '全部版本列表',
            hidden: true,
            canTo: true,
            activeMenu: '/product/lead-product-list'
          }
        },
        {
          path: 'single-product',
          component: () => import('@/views/Product/Lead/SingleProduct/Index.vue'),
          name: 'LeadSingleProduct',
          meta: {
            title: '新增单品',
            hidden: true,
            canTo: true,
            activeMenu: '/product/lead-product-list'
          }
        },
        {
          path: 'combination-product',
          component: () => import('@/views/Product/Lead/CombinationProduct/Index.vue'),
          name: 'LeadCombinationProduct',
          meta: {
            title: '新增组合产品',
            hidden: true,
            canTo: true,
            activeMenu: '/product/lead-product-list'
          }
        },
        {
          path: 'marketing',
          component: () => import('@/views/Product/Lead/Marketing/Index.vue'),
          name: 'LeadMarketing',
          meta: {
            title: '营销信息',
            hidden: true,
            canTo: true,
            activeMenu: '/product/lead-product-list'
          }
        },
        {
          path: 'detail',
          component: () => import('@/views/Product/Lead/ProductDetail/Index.vue'),
          name: 'LeadProductDetail',
          meta: {
            title: '产品详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/lead-product-list'
          }
        }
      ]
    },
    {
      path: 'lead-product-audit',
      component: () => import('@/views/Product/Lead/ProductAudit/Index.vue'),
      name: 'LeadProductAudit',
      meta: {
        title: '领参区产品审批'
      },
      children: [
        {
          path: 'audit-detail',
          component: () => import('@/views/Product/Lead/AuditDetail/Index.vue'),
          name: 'LeadAuditDetail',
          meta: {
            title: '领参区产品审批详情',
            hidden: true,
            canTo: true,
            activeMenu: '/product/lead-product-audit'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
